import type { Props } from "../../core/types/tsx/components/order-detail/SupportCard.types";
import { AlertTriangle } from "lucide-react";

export function SupportCard({ help }: Props) {
	return (
		<aside className='rounded-2xl bg-amber-50 p-6 border border-amber-100'>
			<p className='text-sm font-semibold text-amber-900 mb-2'>{help.title}</p>
			<p className='text-sm text-amber-800 leading-relaxed'>{help.description}</p>
			<button
				type='button'
				onClick={help.onAction}
				disabled={help.actionDisabled || help.actionLoading}
				className='mt-4 inline-flex w-full cursor-pointer items-center justify-center gap-2 rounded-full border border-red-300 bg-white px-4 py-2.5 text-sm font-semibold text-red-600 transition hover:bg-red-50 disabled:cursor-not-allowed disabled:opacity-60'
			>
				<AlertTriangle className='h-4 w-4' />
				{help.actionLoading ? "Procesando..." : help.actionLabel}
			</button>
		</aside>
	);
}

export default SupportCard;
